import { PresentialInstance } from '../../../@academy/catalog/models/PresentialInstance.model';
import { ScheduleAction } from '../../../@academy/catalog/models/ScheduleAction';

export class CourseInstance extends PresentialInstance {

  deletedAt?: string;
  communicationEndDate?: string;
  communicationStartDate?: string;
  closed: boolean;
  fullRemainingAttendeeCapacity: number;
  invoiceBuilding: string;
  remainingAttendeeCapacity: number;
  roomBookings?: [];
  endTime?: string;
  serviceBookings?: [];

  // eslint-disable-next-line constructor-super
  constructor(json?) {
    if (json != null) {
      super(json);
      Object.assign(this, json);
    }
  }

  /**
   * Compares two schedule actions in order to sort them by startTime
   *
   * @param a First schedule action
   * @param b Second schedule action
   */
  public static compareScheduleActions(a: ScheduleAction, b: ScheduleAction): number {
    return a.startTime > b.startTime ? 1 : -1;
  }

  /**
   * Returns end date of course instance based on schedule actions
   */
  getEndDate(): Date {
    let sortedScheduleActions = this.scheduleActions.sort(CourseInstance.compareScheduleActions);
    sortedScheduleActions = sortedScheduleActions.reverse();
    return sortedScheduleActions[0].endTime;
  }

  /**
   * Returns start date of course instance based on schedule actions
   */
  getStartDate(): Date {
    const sortedScheduleActions = this.scheduleActions.sort(CourseInstance.compareScheduleActions);
    return sortedScheduleActions[0].startTime;
  }
}
